var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"catalog"},[_c('slider',{attrs:{"items":_vm.bgnds.bg}}),_c('div',{staticClass:"catalog__items"},_vm._l((_vm.cars),function(car){return _c('catalogitem',{key:car.id,attrs:{"car":car}})}),1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }